@if (bullet(); as bullet) {
  <app-bullet>{{ bullet }}</app-bullet>
}
<div>
  @if (title(); as title) {
    <h2 class="title">{{ title }}</h2>
  }
  <ng-content select="[title]"></ng-content>
  @if (subtitle(); as subtitle) {
    <div class="subtitle">{{ subtitle }}</div>
  }
</div>
